(function(){
  var docEl = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    // Instantly reveal and bail
    document.querySelectorAll('[data-animate], .will-animate').forEach(function(el){ 
      el.classList.add('is-in'); 
    });
    return;
  }

  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });

  document.querySelectorAll('[data-animate], .will-animate').forEach(function(el){
    // default animation type if none provided
    var type = (el.getAttribute('data-animate') || 'fade-up').toLowerCase();
    if (type === 'fade') el.classList.add('a-fade');
    else el.classList.add('a-up');
    io.observe(el);
  });

  // Handle dynamic section renders (Shopify Editor hot-swap safety)
  document.addEventListener('shopify:section:load', function(e){
    (e.target || document).querySelectorAll('[data-animate], .will-animate').forEach(function(el){
      if (!el.classList.contains('is-in')) {
        var type = (el.getAttribute('data-animate') || 'fade-up').toLowerCase();
        if (type === 'fade') el.classList.add('a-fade'); else el.classList.add('a-up');
        io.observe(el);
      }
    });
  });
})();